module.exports = __webpack_public_path__ + "img/sh.shcc6a754.svg";